import { useDeferredValue } from 'react';
import type { EndpointOIDCUser } from '#dn-types/endpoint-oidc-user.ts';
import { EmptyFilteredUsers } from '../empty/EmptyFilteredUsers.tsx';
import { EndpointOIDCUsersTable } from './EndpointOIDCUsersTable.tsx';
import { filterUsers } from './filterUsers.ts';
import { useUsersSearch } from './useUsersSearch.ts';

interface Props {
  users: EndpointOIDCUser[];
}

/**
 * Users who have enrolled devices through an endpoint OIDC provider, filtered by the page's search
 */
export function EndpointOIDCUsersList({ users }: Props) {
  const [search] = useUsersSearch();

  // Filtering runs over the whole max list, which can be thousands of rows; deferring keeps the
  // input responsive while the table catches up.
  const filteredUsers = filterUsers(users, useDeferredValue(search));

  if (filteredUsers.length === 0) {
    return <EmptyFilteredUsers />;
  }

  return <EndpointOIDCUsersTable data={filteredUsers} />;
}
